import DownloadSettingsForm from './DownloadStatisticsForm'

export default DownloadSettingsForm
